<template>
    <li class="nav-item subnav-item flex justify-center">
        <Link :class="{ 'c-active': active }" :href="href" class="nav-link">
            <div class="flex w-full items-center justify-between gap-2">
                <span><slot /></span>
                <span
                    v-if="count !== undefined"
                    :class="active ? 'bg-[#F0F3FB] text-[#2563eb]' : 'bg-[#3F4B68] text-white'"
                    class="h-5 rounded-full bg-[#3F4B68] px-2 text-xs leading-5"
                    >{{ count }}</span
                >
            </div>
        </Link>
    </li>
</template>
<script setup>
defineProps({
    href: String,
    active: Boolean,
    count: Number,
});
</script>
